import TechHero from "../components/TechHero";
import dpImage from "../assets/dp-optimized.png";

export default function Founder() {
  return (
    <div className="space-y-12">
      <TechHero
        kicker="Founder-led delivery"
        title="Meet the Founder"
        subtitle="Hands-on leadership for strategy, product, and engineering—so every decision moves your product forward."
        ctaText="Start a conversation"
      />

      <section className="card rounded-3xl border border-white/30 bg-white/10 backdrop-blur-lg p-8 hover:shadow-2xl hover:bg-white/20 transition-all duration-300">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] items-center">
          <div className="flex flex-col items-start gap-4">
            <img src={dpImage} alt="Founder - Tarannum Mushtaq Ahmed" className="w-48 h-48 rounded-2xl object-cover object-[center_15%] border border-amber-400/50 shadow-lg" />
            <div>
              <h1 className="text-3xl font-bold bg-linear-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent">Tarannum Mushtaq Ahmed</h1>
              <p className="text-amber-400 text-sm font-semibold mt-1">Founder & Lead Full Stack Developer</p>
              <p className="mt-4 text-sm text-gray-100">
                Full-stack developer and founder of ZS NEXATECH, dedicated to transforming ideas into impactful digital solutions.
                I lead projects from discovery to delivery with a focus on clarity, reliability, and business outcomes.
              </p>
            </div>
          </div>
          <div className="grid gap-4">
            <div className="card rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-5">
              <h2 className="text-lg font-semibold text-white">What I focus on</h2>
              <ul className="mt-3 space-y-2 text-sm text-gray-100">
                <li>✅ Product strategy & roadmap alignment</li>
                <li>✅ Architecture, performance, and scalability</li>
                <li>✅ Security-first engineering & QA</li>
                <li>✅ Weekly visibility and clear communication</li>
              </ul>
            </div>
            <div className="card rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-5">
              <h2 className="text-lg font-semibold text-white">Tech stack experience</h2>
              <div className="mt-3 flex flex-wrap gap-2">
                {[
                  "Java",
                  "Spring Boot",
                  "Microservices",
                  "Angular",
                  "React",
                  "Node.js",
                  "AI/ML",
                  "Databases",
                  "Kafka",
                  "Docker",
                  "Kubernetes",
                  "Cloud",
                  "AWS"
                ].map((item) => (
                  <span key={item} className="text-xs bg-amber-500/20 text-amber-300 px-3 py-1 rounded-full">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="grid gap-6 md:grid-cols-2">
        <div className="card rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-6 hover:shadow-2xl hover:scale-105 hover:bg-white/20 transition-all duration-300">
          <h3 className="text-xl font-semibold text-white">Founder message</h3>
          <p className="mt-3 text-sm text-gray-100">
            I believe great products come from deep discovery, transparent delivery, and disciplined engineering. If you need a
            partner who can translate vision into a fast, secure, and scalable product—let’s talk.
          </p>
        </div>
        <div className="card rounded-2xl border border-white/30 bg-white/10 backdrop-blur-lg p-6 hover:shadow-2xl hover:scale-105 hover:bg-white/20 transition-all duration-300">
          <h3 className="text-xl font-semibold text-white">Let’s build together</h3>
          <p className="mt-3 text-sm text-gray-100">
            Get direct founder involvement, weekly demos, and clear milestones from day one.
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href="/contact" className="btn-gold">Book a call</a>
            <a href="/portfolio" className="link-gold">See recent work</a>
          </div>
        </div>
      </section>
    </div>
  );
}
